import { useMemo, useRef } from "react";
import type { PendingScrollRequest } from "./scroll-controller-types";

export interface ScrollControllerRefs {
  messageElementsRef: React.RefObject<Map<string, HTMLElement>>;
  versionElementsRef: React.RefObject<Map<string, HTMLElement>>;
  elementToMessageIdRef: React.RefObject<WeakMap<HTMLElement, string>>;
  visibleMessageIdsRef: React.RefObject<Set<string>>;
  observerRef: React.RefObject<IntersectionObserver | null>;
  isAutoScrollingRef: React.RefObject<boolean>;
  runIdRef: React.RefObject<number>;
  pendingScrollRef: React.RefObject<PendingScrollRequest | null>;
}

export function useScrollControllerRefs(): ScrollControllerRefs {
  const messageElementsRef = useRef<Map<string, HTMLElement>>(new Map());
  const versionElementsRef = useRef<Map<string, HTMLElement>>(new Map());
  const elementToMessageIdRef = useRef<WeakMap<HTMLElement, string>>(
    new WeakMap(),
  );
  const visibleMessageIdsRef = useRef<Set<string>>(new Set());
  const observerRef = useRef<IntersectionObserver | null>(null);
  const isAutoScrollingRef = useRef(false);
  const runIdRef = useRef(0);
  const pendingScrollRef = useRef<PendingScrollRequest | null>(null);

  return useMemo(
    () => ({
      messageElementsRef,
      versionElementsRef,
      elementToMessageIdRef,
      visibleMessageIdsRef,
      observerRef,
      isAutoScrollingRef,
      runIdRef,
      pendingScrollRef,
    }),
    [
      messageElementsRef,
      versionElementsRef,
      elementToMessageIdRef,
      visibleMessageIdsRef,
      observerRef,
      isAutoScrollingRef,
      runIdRef,
      pendingScrollRef,
    ],
  );
}
